import { Subscription, Observable, fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { Injectable } from "@angular/core";

@Injectable()
export class EventsService {
  public _observables: { [element: string]: Array<EventObservable> } = {}// = new Map<string, Observable<any>>();
  public _owners: Array<EventOwner> = new Array<EventOwner>();
  /**
   * Creates a subscription
   * @param owner
   * @param element
   * @param event
   * @param func
   */
  public create(owner: any, element: any, event: string, func: Function): void {
    let _owner = this._owners.find(x => x.name === owner);
    //Do we have the owner?
    if (!_owner) {
      _owner = new EventOwner(owner);
      this._owners.push(_owner);
    }
    let ownerEvents = _owner.events[`${element}`];
    //Do we have the events for the owner?
    if (!ownerEvents) {
      ownerEvents = new Array<Event>();
      _owner.events[`${element}`] = ownerEvents;
    }
    let eventContext = ownerEvents.find(x => x.name === event);
    //Do we have the subscriptions for the event?  If we do, exit.
    if (eventContext)
      return;
    eventContext = new Event(event);
    ownerEvents.push(eventContext);
    //Do we a list of observables associated with the element?
    let eventObservables = this._observables[`${element}`];//.get(event);
    if (!eventObservables) {
      eventObservables = new Array<EventObservable>();
      this._observables[`${element}`] = eventObservables;
    }
    //Do we have an observable with the correct event?
    let observer = eventObservables.find(x => x.name === event);
    if (!observer) {
      observer = new EventObservable(event);
      observer.observable = fromEvent(element, event).pipe(debounceTime(100));
      eventObservables.push(observer);
    }
    this.createSubscription(eventContext, observer, func);
  }
  /**
   * Removes a owners entired subscription
   * @param owner
   */
  public remove(owner: any): void {
    let eventOwnerIndex = this._owners.findIndex(x => x.name === owner);
    if (eventOwnerIndex < 0)
      return;
    let eventOwner = this._owners[eventOwnerIndex];
    for (let eventKey in eventOwner.events) {
      let elementEvents = eventOwner.events[eventKey];
        for (let event in elementEvents) {
            if (elementEvents[event].subscription)
            elementEvents[event].subscription.unsubscribe();
        }
    }
    this._owners.splice(eventOwnerIndex, 1);
  }
  /**
   * Creates a subscription for a provided EventObservable.  Timeout is required because the system needs to process the event.
   * @param context Event
   * @param observer Observer
   * @param func Function to be called upon subscribe
   */
  public createSubscription(context: Event, observer: EventObservable, func: Function): void {
    setTimeout(() => context.subscription = observer.observable.subscribe(x => func(x)), 0);
  }
}
export class EventOwner {
  public events: { [element: string]: Array<Event> } = {}
  constructor(public name: string) { }
}
export class Event {
  public subscription: Subscription;
  constructor(public name: string) { }
}
export class EventObservable {
  public observable: Observable<any>;
  constructor(public name: string) { }
}
